import React from 'react';
import { Link } from 'react-router-dom';

const ChallengeCard = ({ challenge }) => {
  return (
    <div className="bg-cardBackground p-4 rounded-lg shadow-md hover:shadow-neon transition-shadow">
      <h3 className="text-xl font-semibold text-textWhite mb-2">{challenge.name}</h3>
      <p className="text-gray-400">{challenge.description}</p>
      <p className={`mt-2 text-sm font-semibold ${getDifficultyColor(challenge.difficulty)}`}>
        difficulty: {challenge.difficulty}
      </p>
      <Link to={`/challenge/${challenge.id}`} className="text-cyberBlue hover:underline mt-4 inline-block">
        View Challenge
      </Link>
    </div>
  );
};

// Helper function to add color styling based on difficulty level
const getDifficultyColor = (difficulty) => {
  switch (difficulty) {
    case 'beginner':
      return 'text-green-400';
    case 'easy':
      return 'text-blue-400';
    case 'medium':
      return 'text-yellow-400';
    case 'hard':
      return 'text-orange-400';
    case 'extreme':
      return 'text-red-500';
    case 'impossible':
      return 'text-purple-600';
    default:
      return 'text-gray-400';
  }
};

export default ChallengeCard;
